<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header">
      <h3>
        Registered Users
        <span class="btn-wrapper">
          <button type="button" class="btn btn-success btn-sm me-1">
            <fa-icon [icon]="['fal','sync']" (click)="reload()"></fa-icon>
          </button>
        </span>
        <span class="btn-wrapper" placement="top" [ngbTooltip]="canEdit? '':'Insufficent permission'" container="body">
          <button type="button" (click)="openCreateModal()" class="btn btn-primary btn-sm" [disabled]="!canEdit">
            <fa-icon [icon]="['fal','plus']"></fa-icon> Create User
          </button>
        </span>
      </h3>
      <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="user" size="lg" [fixedWidth]="true"></fa-icon>
    </div>
    <div class="card-body">
      <user-page-view
        [entries]="entries"
        [columns]="{uuid: false, username: true, fullname: true, mail: true, labels: false, roles: true, registered: false, created: null, expiry: true}"
        [roles]="roles | async"
        [clearSelection]="clearSelectionChange"
        (onUpdate)="openUpdateModal($event)"
        (onUpdated)="update($event, null, [])"
        (onUpdateMulti)="openUpdateMultiModal($event)"
        (onDelete)="delete($event)"
        (onDeleteMulti)="deleteMulti($event)"
        [canDelete]="canDelete"
        [canEdit]="canEdit"
      ></user-page-view>
    </div>
  </div>
</div>
